import React, { useState, useEffect } from 'react';
import axios from '../../../interceptors/interceptors';
import { logEventHub } from '../utils';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import '../../../stylesheets/triagebot/SymptomSearchMenu.scss';
import { data } from 'react-router-dom';

let searchPromise;
const symptomBodySearchUrl = '/api/symptom-search/body';
const env = process.env.REACT_APP_ASYNC_ENVIRONMENT;

//******************************//

const SymptomSearchMenu = ({ message, showMenu, onClose, bodyPart, bodyPartQueryTerm, age, gender, tags, setTags, setBodyPartHover }) => {
    const [loadState, setLoadState] = useState('INIT');
    const [suggestions, setSuggestions] = useState([]);
    const [selection, setSelection] = useState(-1);
    const [show, setShow] = useState(showMenu);

    const helpText = (message?.data[0]?.trySearch)
        ? message?.data[0]?.trySearch
        : ""
    
   const language= (message?.language)
    ? message?.language
    : '';

    const asyncHBID = message?.AsyncHBID || 'Correlation-Id';

   
    useEffect(() => {
        if (!bodyPartQueryTerm) return;

        setLoadState('LOADING');

        let requestHeaders = {
            "Content-Type": "application/json",
               "Correlation-Id": asyncHBID
        }; 
      
        if (env && env.toLowerCase() !== "production") {
            requestHeaders['x-upstream-env'] = "nonprod";
        }

        const requestData ={
            body_part: bodyPartQueryTerm,
            sex: gender,
            age_in_years: age,
            language: language
        }

        searchPromise = axios({
            method: "post",
            url: symptomBodySearchUrl,
            headers: requestHeaders,
            data:requestData
          });

        const localPromise = searchPromise;
         logEventHub(`symptom menu search: ${JSON.stringify(requestData || [])}`, 'FE - symptom search menu', asyncHBID);
        // NOTE: This works for single instances only. 
        searchPromise.then(response => {
            if (searchPromise === localPromise) {
                setLoadState("DONE");

                const results = response?.data?.data || [];
                const seenIds = new Set();
                const uniqueResults = results.filter(symptom => {
                    if (seenIds.has(symptom.id)) return false;

                    seenIds.add(symptom.id);
                    return true;
                });

                setSuggestions(uniqueResults);
            }
        })
            .catch(function (error) {
                logEventHub('Failed request symptom menu search.', 'FE - symptom search menu', asyncHBID, 'error');

                if (searchPromise === localPromise) {
                    setLoadState("DONE");
                    setSuggestions([]);
                }
            });

        setShow(showMenu);
    }, [age, bodyPartQueryTerm, gender, bodyPart, showMenu])

    const isSymptomSelected = (symptom) => {
        return tags.some(tag => tag.id === symptom.id);
    }

    const toggleSymptom = (symptom) => {
        if (isSymptomSelected(symptom)) {
            setTags(tags.filter(tag => tag.id !== symptom.id));
            return;
        }

        setTags([...tags, symptom]);
    }

    const sentenceCase = (text) => {
        if (!text) return text;

        return text.slice(0, 1).toUpperCase() + text.slice(1).toLowerCase();
    }

    useEffect(() => {
        if (!show)
            return;

        if (selection !== 0 && !selection)
            return;

        if (typeof setBodyPartHover !== 'function')
            setBodyPartHover = () => { };

        if (!suggestions) {
            setBodyPartHover("");
            return;
        }

        if (selection < 0 || selection > (suggestions.length - 1)) {
            setBodyPartHover("");
            return;
        }

        setBodyPartHover(suggestions[selection].body_parts[0]);
    })



    return (
        show
            ?
            <div className='symptom-menu' >
                <div
                    onClick={onClose}
                    className='closer'>
                </div>
                <div className='header' style={{ marginTop: '0em' }}>
                    <h2 className='headerText'>{bodyPart}</h2>
                    <p className='selection-instructions'>
                        Select one or more symptoms
                    </p>
                    <button title='Close dialog' className='button-close' onClick={onClose}>
                        <CloseIcon
                            className='close'
                            role="img" aria-labelledby="close-label"
                            aria-hidden={false}
                        />
                    </button>
                </div>
                <div className='body'>
                    {
                        (loadState === 'LOADING')
                            ?
                            <div className='loading'>
                                {
                                    Array.from({ length: 3 }, (x, i) => {
                                        return (
                                            <div key={'waitbar' + i} className='loadAnim' style={{ opacity: 1 - (i * .22) }}>
                                                <div className='anim'>&nbsp;</div>
                                            </div>)
                                    })
                                }
                            </div>
                            :
                            <>
                                <ul>
                                    {
                                        suggestions.map((symptom, i) => {
                                            const selected = isSymptomSelected(symptom);

                                            return (
                                                <li
                                                    key={symptom.id + "_" + i}
                                                    className={
                                                        [
                                                            'suggestion',
                                                            i === selection ? 'selected' : '',
                                                            selected ? 'checked' : ''
                                                        ].filter(Boolean).join(' ')
                                                    }
                                                    role='checkbox'
                                                    aria-checked={selected}
                                                    tabIndex={0}
                                                    onMouseEnter={() => { setSelection(i) }}
                                                    onMouseLeave={() => { setSelection(-1) }}
                                                    onClick={() => toggleSymptom(symptom)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter' || e.key === ' ') {
                                                            e.preventDefault();
                                                            toggleSymptom(symptom);
                                                        }
                                                    }}
                                                    title={sentenceCase(symptom.name)}
                                                >
                                                    {
                                                        selected
                                                            ? <CheckIcon className='check' aria-hidden={true} />
                                                            : null
                                                    }
                                                    <span className='suggestion-text'>
                                                        {
                                                            sentenceCase(symptom.name)
                                                        }
                                                    </span>
                                                </li>)
                                        })
                                    }
                                    <li>
                                        <div
                                            className='help'
                                            onClick={onClose}
                                        >
                                            {helpText}
                                        </div>
                                    </li>
                                </ul>
                            </>
                    }
                </div>
            </div>
            : <></>
    );
};

export default SymptomSearchMenu;